"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    empty: {
        en: "Empty",
        es: "Vacío",
    },
    maskAsRead: {
        en: "Read all ",
        es: "Marcar leídas las ",
    },
    alertDisabled: {
        en: "Alert Disabled",
        es: "Alerta Desactivada",
    },
    alertDisabledByAdmin: {
        en: "This alert was disabled, contact your admin",
        es: "Esta alerta fue desactivada, contactar administrador",
    },
    alertWhen: {
        en: "Alert when",
        es: "Alertar cuando ",
    },
    alertTitle: {
        en: "Alerts",
        es: "Alertas",
    },
    all: {
        en: "Configure selected units",
        es: "Configurar unidades seleccionadas",
    },
    checkAll: {
        en: "Check all",
        es: "Seleccionar todos",
    },
    checkAllCount: {
        en: "Check all ({count})",
        es: "Seleccionar todos ({count})",
    },
    desktop: {
        en: "Desktop alert",
        es: "Alerta de escritorio.",
    },
    temporary: {
        en: "Temporary",
        es: "Temporal",
    },
    persistent: {
        en: "Persistent",
        es: "Persistir",
    },
    mobile: {
        en: "Mobile alert",
        es: "Alerta de celular.",
    },
    emailAlert: {
        en: "Email alert",
        es: "Alerta de correo",
    },
    smsAlert: {
        en: "SMS alert",
        es: "Alerta de SMS",
    },
    persistentMessage: {
        en: "This is a persistent notification",
        es: "Esta es una notificación persistente.",
    },
    temporaryMessage: {
        en: "This is a temporary notification",
        es: "Esta es una notificación temporal",
    },
    dismiss: {
        en: "Dismiss",
        es: "Cerrar",
    },
    seconds: {
        en: "seconds",
        es: "seconds",
    },
    EmailActivated: {
        en: "Your account has been activated! you will be redirected in ",
        es: "Tu correo electrónico a sido verificado! Serás redireccionado en ",
    },
    SmsActivated: {
        en: "Your number has been verified! you will be redirected in ",
        es: "Tu numero celular a sido verificado! Serás redireccionado en ",
    },
    traceNotFound: {
        en: "There is no information on that date, {date} was loaded instead.",
        es: "No hay información ese día, se cargo el {date} en su lugar.",
    },
    noTraceFoundToday: {
        en: "No trace information available for today.",
        es: "No hay información de rastro disponible para el dia de hoy.",
    },
    smsVerification: {
        en: "SMS verification",
        es: "Verificación de SMS",
    },
    emailVerification: {
        en: "Email verification",
        es: "Verificación de correo electrónico",
    },
    validRange: {
        en: "Please enter a valid range of hours",
        es: "Por favor ingresar rango de horas validos",
    },
    sameRange: {
        en: "Both hours are the same please enter a valid range of hours",
        es: "Ambas horas son iguales, por favor ingresar rango de horas validos",
    },
    inOrOutRange: {
        en: "The selected range is in or out of another range, please entre a valid range.",
        es: "El rango seleccionado esta dentro o fuera de otro rango, por favor ingrese rango valido.",
    },
    autorizeSchedule: {
        en: "Authorized Schedule",
        es: "Horario Autorizado",
    },
    authorizeScheduleConfigTitle: {
        en: "Schedule",
        es: "Horario",
    },
    unAuthorizeSchedule: {
        en: "Activity outside authorized hours",
        es: "Actividad fuera de horario autorizado",
    },
    addAuthorizedSchedule: {
        en: "Add Schedule",
        es: "Agregar Horario",
    },
    authorizedScheduleOverlapError: {
        en: "One or more schedules overlaps each other.",
        es: "Uno o mas horarios colisionan entre ellos.",
    },
    authorizedScheduleSameFromToError: {
        en: "Schedules can not starts at the same time they end.",
        es: "El horario no puede iniciar al mismo tiempo que termina.",
    },
    authorizedScheduleEmptyError: {
        en: "At least one schedule has to exist in the configuration.",
        es: "Al menos un horario debe existir en la configuración.",
    },
    authorizedScheduleEmptyDayError: {
        en: "All schedule should have at least one day selected.",
        es: "Todos los horarios deben tener al menso un día seleccionado.",
    },
    fotoInProcessTitle: {
        en: "Processing new Photo.",
        es: "Procesando Nueva Fotografía.",
    },
    fotoProcessedTitle: {
        en: "Photo processed.",
        es: "Fotografía Procesada.",
    },
    fotoInProcess: {
        en: "An image is been processing for unit {description}.",
        es: "Se esta procesando una foto de la unidad {description}.",
    },
    fotoProcessed: {
        en: "An image finished processing for unit {description}.",
        es: "Se termino de procesar una foto de la unidad {description}.",
    },
    reportReadyToDownload: {
        en: "The report {name} has been processed, check your email or click on the download button.",
        es: "Se termino de procesar el reporte  de {name}, revisa tu correo o has click en el botón de descarga.",
    },
    displacementAlert: {
        en: "Displacement Alert {description}",
        es: "Alerta de desplazamiento {description}",
    },
    busyDriver: {
        en: "{driver} it's assigned to another device, assign to this device anyway?",
        es: "{driver} está asignado a otro vehículo, ¿Asignar a este vehículo de todas formas?",
    },
    deleteDriver: {
        en: "Do you want to remove {driver}?",
        es: "Quieres eliminar a {driver}?",
    },
    mobileNotifications: {
        en: "Mobile app notifications",
        es: "Notificaciones en la app móvil",
    },
    emailNotifications: {
        en: "Email notifications",
        es: "Notificaciones vía email",
    },
    emailNotificationsMessage: {
        en: "The entered email addresses will receive a mail to activate the notifications.",
        es: "Se enviará un correo a las direcciones ingresadas para activar las notificaciones.",
    },
    smsNotifications: {
        en: "SMS notifications",
        es: "Notificaciones vía SMS",
    },
    smsNotificationsMessage: {
        en: "An activation link will be send to the entered numbers.",
        es: "Se enviará un link de activación a los números ingresados.",
    },
    selectMinutes: {
        en: "Select minutes",
        es: "Seleccionar minutos",
    },
    liveEndedTitle: {
        en: "Live transmission ended",
        es: "La transmisión en vivo termino",
    },
    liveEndedDisclamer: {
        en: "To protect your data usage the live-streaming will last 2 minutes, click play to start again.",
        es: "Para proteger tus datos la transmisión solo durara 2 minutos, haga clic en reproducir para comenzar de nuevo.",
    },
    videoLifetimeDisclaimer: {
        en: 'Videos are retained for 3 months and will be permanently deleted after that period. Please download them before they expire.',
        es: 'Los videos se conservan durante 3 meses y se eliminarán permanentemente después de ese período. Por favor, descárgalos antes de que expiren.'
    },
    recordDeleted: {
        en: 'Record deleted',
        es: 'Registro eliminado'
    },
    groupDeleted: {
        en: 'Group deleted',
        es: 'Grupo eliminado'
    },
    doNotShow: {
        en: "Don't show again",
        es: 'No volver a mostrar',
    },
    remindLater: {
        en: 'Remind me later',
        es: 'Recordar más tarde'
    }
};
exports.default = translations;
